import { useMemo } from 'react'
import useDataFetcher from '../../main/second/mainbar/knisot/hooks/useFetchData'
import { Warehouse } from '../../modules/API/Warehouse/warehouse'
import { IWarehouseLocation, IWarehouseLocationsResponse } from '../../modules/API/Warehouse/models/locations'

export const getActiveLocations = (locations: IWarehouseLocation[] | null): IWarehouseLocation[] | null => {
    if (!locations) return null
    return locations.filter((l) => l.Active)
}

export const findLocationByCode = (locations: IWarehouseLocation[] | null, code: string): IWarehouseLocation | null => {
    const q = code.trim().toLowerCase()
    if (!q || !locations) return null
    return locations.find((l) => l.CodeLocation.trim().toLowerCase() === q) ?? null
}

export interface UseWarehouseLocationsReturn {
    locations: IWarehouseLocation[] | null
    isLoading: boolean
    error: string | null
}

export const useWarehouseLocations = (): UseWarehouseLocationsReturn => {
    const { data, isLoading, error } = useDataFetcher<IWarehouseLocationsResponse>(
        Warehouse.getLocationList, 'data'
    )
    const locations = useMemo(() => getActiveLocations(data?.locations ?? null), [data])
    return { locations, isLoading, error }
}
